import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class UploadService {

  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public uploadCylinders(base64String: string, web_User_Id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      var uploadFileDto = {
        File: base64String,
        Web_User_Id: web_User_Id
      };

      this.http.post(environment.apiUrl + 'upload/uploadCylinders', uploadFileDto).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error);
      });

    });
  }

  public uploadDeliveriesCollections(base64String: string, web_User_Id: string, upload_Type: number, company_Id: number, location_Id: number, date: string): Promise<any> {
    return new Promise((resolve, reject) => {
      var uploadFileDto = {
        File: base64String,
        Web_User_Id: web_User_Id,
        Upload_Type: Number(upload_Type),
        Company_Id: Number(company_Id),
        Location_Id: Number(location_Id),
        Date: date
      };

      console.log("Upload ---------------");
      console.log(uploadFileDto);
      this.http.post(environment.apiUrl + 'upload/uploadDeliveriesCollections', uploadFileDto).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error);
      });

    });
  }

  public uploadFillBatch(base64String: string, firstname: string, lastname: string, batch_Num: string, pressure_Id: number, fill_Date: string, expiry_Date: string): Promise<any> {
    return new Promise((resolve, reject) => {
      var uploadFileDto = {
        File: base64String,
        Web_User_First_Name: firstname,
        Web_User_Last_Name: lastname,
        Batch_Num: batch_Num,
        Pressure_Id: Number(pressure_Id),
        Fill_Date: fill_Date,
        Expiry_Date: expiry_Date
      };

      console.log("upload file dto", uploadFileDto);
      

      console.log(uploadFileDto);
      this.http.post(environment.apiUrl + 'upload/uploadFillBatch', uploadFileDto).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error);
      });

    });
  }


  /*public uploadEquipmentFile(base64String: string): Promise<any> {
    console.log("SERVICE");
    console.log(base64String);
    return new Promise((resolve, reject) => {
      var uploadFileDto = {
        FileData: base64String
      };

      this.http.post('/api/massupload/upload', uploadFileDto).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully added equipment');
      }, error => {
        reject(error);
      });

    });
  }*/

}
